import React from "react";

import { useNavigate } from "react-router-dom";
import ListItem from "../../partials/listItem";
import { Col } from "react-bootstrap";
import { Button, Typography } from "@mui/material";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

export default function TermItem(props) {
  const navigate = useNavigate();
    console.log(props.item);
  const item = {
    title: props.item.label
  };

  return (
    <>
      <ListItem item={item} owner="client" variant="taxonomy" titleColXs={3}>
        <Col xs={6}></Col>
        <Col xs={3} className="d-flex justify-content-end">
          <Button
            variant="text"
            owner="client"
            onClick={() => {
                const route = `/taxonomies/term/${props.item.vid}/${props.item.tid}`
                navigate(route)
            }
            }
            endIcon={<EditOutlinedIcon sx={{height:"16px"}}/>}
          >
            <Typography owner="client" variant="button">
              Edit
            </Typography>
          </Button>
        </Col>
      </ListItem>
    </>
  );
}
